export const locales = Object.freeze({
    en: 'en',
    enUS: 'en-US',
    zh: 'zh',
    zhCN: 'zh-CN',
    ja: 'ja',
    jaJP: 'ja-JP',
    ko: 'ko',
    koKR: 'ko-KR',
    ru: 'ru',
    ruRU: 'ru-RU',
    id: 'id',
    idID: 'id-ID',
})

export const availableLocales = [locales.en, locales.ru, locales.ja, locales.ko, locales.zh, locales.id]

export const getCurrentLocale = (dontPassDefaultEn?: 'dontPassDefaultEn') => {
    const possibleLocale = window.location.pathname.slice(1, 3)
    return availableLocales.includes(possibleLocale)
      ? possibleLocale
      : (dontPassDefaultEn ? '' : locales.en)
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/locales.tsx